module.exports = __webpack_public_path__ + "static/betis-MONEI-00701c232429d3c9b7743006bfa68936.png";